<template>
  <div>
    <b-nav-item-dropdown no-caret :right="!isRTL" class="custom-navbar">
      <template slot="button-content">
        <span class="px-1 mr-lg-2 ml-2 ml-lg-0">{{ tempoRestanteSessao }}</span>
        <i
          class="ion ion-md-stopwatch navbar-icon align-middle"
          v-bind:style="colorClock"
          style="color: green"
        ></i>
      </template>

      <b-dd-item
        class="media d-flex align-items-center"
        v-on:click="validarRefreshToken"
      >
        <div
          class="ui-icon ui-icon-sm ion ion-md-refresh bg-secondary border-0 text-white"
        ></div>
        <div class="media-body line-height-condenced ml-1">
          <div class="text-dark">Renovar Sessão</div>
        </div>
      </b-dd-item>
    </b-nav-item-dropdown>

    <ValidarChaveSeguranca
      @proximoPassoValidacaoToken="reiniciarToken"
      ref="validarchaveseguranca"
    ></ValidarChaveSeguranca>
  </div>
</template>

<script>
import ValidarChaveSeguranca from '../../views/mfafisico/ValidarChaveSeguranca.vue'

export default {
  components: {
    ValidarChaveSeguranca
  },
  data() {
    return {
      tempoRestanteSessao: '',
      tempo: 0,
      clockColor: 'green',
      user: null,
      msg: 'Deseja renovar a sessão?',
      realizouDesafioChave: false
    }
  },
  methods: {
    startCountdown() {
      let th = this
      th.setExpirationTime()
      if (th.tempo > 0) {
        let min = parseInt(th.tempo / 60)
        let seg = th.tempo % 60

        if (min < 10) {
          min = '0' + min
          min = min.substr(0, 2)
          if (min == 0) th.clockColor = 'gold'
          else th.clockColor = 'green'
        }
        if (seg <= 9) seg = '0' + seg

        th.tempoRestanteSessao = min + ':' + seg

        setTimeout(function () {
          th.startCountdown()
        }, 1000)
      } else {
        th.clockColor = 'red'
        th.tempoRestanteSessao = '00:00'
        th.$api.UI.Confirmacao(
          'Deseja renovar a sessão?',
          th.validarRefreshToken,
          th.logout,
          'Sessão expirada.'
        )
      }
    },
    setExpirationTime() {
      let status = localStorage.getItem('status')
      this.user = JSON.parse(localStorage.getItem('user'))
      if (status) {
        if (status == 'loggedIn') {
          while (!this.user) {
            this.user = JSON.parse(localStorage.getItem('user'))
          }

          let dataExpiracao = new Date(this.user.expiresAt)
          let dataAtual = new Date()
          this.tempo = Math.trunc(
            (dataExpiracao.getTime() - dataAtual.getTime()) / 1000
          )
        }
      }
    },
    logout() {
      const th = this

      th.$api.Autenticacao.LogoutOperador()
        .then(function (data) {
          if (th.$api.UI.PostLoadData(data)) {
            th.$store.commit('CLEAR_USER_DATA')
          }
        })
        .catch(err => console.log(err))
    },
    validarRefreshToken() {
      let th = this

      if (th.user.chaveSegurancaAtiva) {
        th.$api.Autenticacao.SolicitarValidacaoChave().then(data => {
          if (data.sucess) {
            setTimeout(() => {
              if (!this.realizouDesafioChave) th.logout()
            }, 15000)

            th.realizouDesafioChave = false

            localStorage.setItem('challenge', JSON.stringify(data))
            th.$refs.validarchaveseguranca.openModal()
          } else {
            setTimeout(th.logout(), 3000)
          }
        })
      } else {
        th.reiniciarToken()
      }
    },
    reiniciarToken(challengeResponse) {
      let th = this
      th.$store.dispatch('limparChallenge')

      if (challengeResponse) th.realizouDesafioChave = true

      th.$api.Autenticacao.RefreshTokenOperador(
        th.user.refreshToken,
        challengeResponse
      )
        .then(function (data) {
          if (data.accessToken) {
            th.$store.dispatch('setUserData', {
              email: data.email,
              token: data.accessToken,
              refreshToken: data.refreshToken,
              roles: th.getUserRole(data.accessToken),
              expiresAt: new Date(new Date().getTime() + data.expires * 1000),
              identificador: data.identificador,
              chaveSegurancaAtiva: Boolean(challengeResponse)
            })

            th.user = data

            if (th.tempo == 0) {
              setTimeout(function () {
                th.startCountdown()
              }, 500)
            }

            let dataExpiracao = new Date(
              new Date().getTime() + data.expires * 1000
            )
            let dataAtual = new Date()
            th.tempo = Math.trunc(
              (dataExpiracao.getTime() - dataAtual.getTime()) / 1000
            )
          } else {
            th.$api.UI.ShowError('Erro', 'Não foi possível renovar a sessão.')
            setTimeout(th.logout(), 3000)
          }
        })
        .catch(err => console.log(err))
    },
    getUserRole(jwtToken) {
      try {
        var base64Url = jwtToken.split('.')[1]
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        var jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split('')
            .map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join('')
        )

        var roles = JSON.parse(jsonPayload).roles
        return JSON.parse(roles)
      } catch {
        const jwtData = jwtToken.split('.')[1]
        const decodedJwtJsonData = window.atob(jwtData)
        return JSON.parse(decodedJwtJsonData).roles
      }
    }
  },
  mounted: function () {
    this.setExpirationTime()
    if (this.tempo > 0) this.startCountdown()
  },
  computed: {
    colorClock: function () {
      let th = this
      return {
        color: th.clockColor
      }
    },
    bakgroundColor: function () {
      let th = this
      return {
        backgroundColor: th.clockColor
      }
    }
  }
}
</script>
